import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	loadingContainer: {
		height: 200,
	},
	filterContainer: {
		gap: 8,
		alignItems: 'center',
	},
	noResultsContainer: {
		padding: '40px 20px',
		color: '#6b7280',
	},
	warningText: {
		color: '#ef4444',
		fontWeight: 600,
		marginTop: 12,
	},
	actionPlaceholder: {
		height: 32,
	},
	sourceLink: {
		textDecoration: 'none',
		color: 'inherit',
		maxWidth: '200px',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		display: 'inline-block',
		':hover': {
			textDecoration: 'underline',
		},
	},
});
